// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 632 ? "notifications-worker" : chunkId) + "." + {"228":"60a1e29d","632":"95dfcc73"}[chunkId] + ".chunk.js";
};